// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.center-title[data-v-95f56456] {
  text-align: center;
  width: 100%;
  font-family: var(--font-family);
  font-weight: 800;
  font-size: 18px;
}
.center-question.v-card__text[data-v-95f56456],
.center-question[data-v-95f56456] {
  text-align: center;
  font-size: 16px;
  color: #253035;
  padding: 33px;
}
.v-dialog > .v-card > .v-card__actions.center-actions > .spacer[data-v-95f56456] {
  flex-grow: unset !important;
}
.v-dialog > .v-card > .v-card__actions.center-actions[data-v-95f56456],
.center-actions[data-v-95f56456] {
  padding-bottom: 26px;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./js/modules/assurance/components/dialogs/Confirm.vue","webpack://./Confirm.vue"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,WAAA;EACA,+BAAA;EACA,gBAAA;EACA,eAAA;ACAF;ADGA;;EAEE,kBAAA;EACA,eAAA;EACA,cAAA;EACA,aAAA;ACAF;ADGA;EACE,2BAAA;ACAF;ADGA;;EAEE,oBAAA;EACA,uBAAA;ACAF","sourcesContent":["\n.center-title {\n  text-align: center;\n  width: 100%;\n  font-family: var(--font-family);\n  font-weight: 800;\n  font-size: 18px;\n}\n\n.center-question.v-card__text,\n.center-question {\n  text-align: center;\n  font-size: 16px;\n  color: #253035;\n  padding: 33px;\n}\n\n.v-dialog > .v-card > .v-card__actions.center-actions > .spacer {\n  flex-grow: unset!important;\n}\n\n.v-dialog > .v-card > .v-card__actions.center-actions,\n.center-actions {\n  padding-bottom: 26px;\n  justify-content: center;\n}\n",".center-title {\n  text-align: center;\n  width: 100%;\n  font-family: var(--font-family);\n  font-weight: 800;\n  font-size: 18px;\n}\n\n.center-question.v-card__text,\n.center-question {\n  text-align: center;\n  font-size: 16px;\n  color: #253035;\n  padding: 33px;\n}\n\n.v-dialog > .v-card > .v-card__actions.center-actions > .spacer {\n  flex-grow: unset !important;\n}\n\n.v-dialog > .v-card > .v-card__actions.center-actions,\n.center-actions {\n  padding-bottom: 26px;\n  justify-content: center;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
